// extracted by mini-css-extract-plugin
export var circle = "_dg-1";
export var exitConfirmationModal = "_dg-5";
export var iframe = "_dg-0";
export var offline = "_dg-3";
export var online = "_dg-2";
export var workstationSelectError = "_dg-4";